import React from 'react';
import { Provider } from 'react-redux';
import store from '../redux/store';
import TemaProvider from '../providers/tema/TemaProvider';
import AutenticacaoProvider from '../providers/autenticacao/AutenticacaoProvider';
import SnackbarProvider from '../providers/snackbar/SnackbarProvider';
import DialogProvider from '../providers/dialog/DialogProvider';

function ListagemProvider(
    {
        children
    }
) {
    return (
        <Provider store={store}>
            <TemaProvider>
                <AutenticacaoProvider>
                    <SnackbarProvider>
                        <DialogProvider>
                            {children}
                        </DialogProvider>
                    </SnackbarProvider>
                </AutenticacaoProvider>
            </TemaProvider>
        </Provider>
    );
}

export default ListagemProvider;